import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { NgModule } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-manufacturer',
  templateUrl: './edit-manufacturer.component.html',
  styleUrls: ['./edit-manufacturer.component.scss'],
})
export class EditManufacturerComponent {
  manufacturerDetails: Manufacturer = new Manufacturer();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private manufacturerService: ManufacturersService,
    private toastr: ToastrService
  ) {}

  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  NameError: boolean = false;

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      loggedInuserRole.role == 'Standard User' ||
      loggedInuserRole.role == 'Internal User' ||
      loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);
        if (id) {
          this.manufacturerService.getManufacturer(id).subscribe({
            next: (response) => {
             
              this.manufacturerDetails = response;
              console.log(this.manufacturerDetails);
            },
          });
        }
      },
    });
  }

  validation() {
    let isValid = true;

    if (this.manufacturerDetails.Name == "") {
      this.NameError = true;
      isValid = false;
    } else {
      this.NameError = false;
    }
    return isValid;
  }

  updateManufacturer() {
    const dateNowISO = this.dateNow.toISOString();
    this.manufacturerDetails.UpdatedAt = dateNowISO;
    if (this.validation()) {
      this.manufacturerService
      .updateManufacturer(this.manufacturerDetails.Id, this.manufacturerDetails)
      .subscribe({
        next: (response) => {
          this.toastr.success(
            'Element Manufacturer Updated Successfully.',
            'Information'
          );
          this.router.navigate(['/manufacturers']);
        },
      });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }
    
  }

  deleteManufacturer(id: number) {
    this.manufacturerService.deleteManufacturer(id).subscribe({
      next: (response) => {
        this.toastr.error(
          'Element Manufacturer Deleted Successfully.',
          'Information'
        );
        this.router.navigate(['/manufacturers']);
      },
    });
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
